import React, {useMemo} from "react";
import {useLocation} from "react-router";
import * as queryString from "./query-string";

export function useLocationSearchParams(extractor) {
    const {search} = useLocation();
    return useMemo(() => extractor(queryString.parse(search)), [search]);
}
